const baseApi = process.env.REACT_APP_BASE_API;
const paymentGatewayBaseApi = process.env.REACT_APP_PAYMENT_GATEWAY_BASE_API;
const socketApi = process.env.REACT_APP_SOCKET_API;
const companyId = process.env.REACT_APP_COMPANY_SLUG;
const instrumentationKey = process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY;

export const network = {
    baseApi,
    socketApi,
    paymentGatewayBaseApi
};
export const company = {id: companyId};
export const ikey = instrumentationKey;
